/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useState } from "react";
import { NewJobsSummary } from "./NewJobsSummary";
import { TestsSummary } from "./TestsSummary";
import { LessonsSummary } from "./LessonsSummary";
import { PaymentSummary } from "./PaymentSummary";
import { DashboardAlerts } from "./DashboardAlerts";
import { PrismicNotification } from "./PrismicNotification";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../setup";

interface ActionCentreProps {
  onLoaded: () => void
  allDone: boolean
}
const ActionCentre: FC<ActionCentreProps>= ({ onLoaded, allDone }) => {
  const [newJobsCount, setNewJobsCount] = useState<any>(null);
  const [canShowPrismicNotification, setCanShowPrismicNotification] =
    useState(false);
  const canSeeBanners = useSelector<RootState>(
    ({ auth }) => auth?.personalData?.can_see_banners
  );
  var newJobsSummary = (
    <NewJobsSummary
      setIsDocumentMissing={false}
      setNewJobsCount={setNewJobsCount}
      onLoaded={onLoaded} 
      allDone={allDone}
    />
  );

  return (
    <>
      {canSeeBanners == 1 && allDone &&
        (canShowPrismicNotification ? (
          <PrismicNotification />
        ) : (
          <DashboardAlerts
            onLoaded={onLoaded} 
            allDone={allDone}
            showPrismicNotification={() => setCanShowPrismicNotification(true)}
          />
        ))}
      <div className="w-full pt-0">
        <h3 className="text-xs text-darkBlue font-medium mb-1">
          Action Centre
        </h3>
        <div className="w-full sm:max-w-full">
          {/* ----start:: JOBS---- */}
          <> {newJobsSummary} </>
          {/* ----end:: JOBS---- */}
          {/* ----start:: TEST---- */}
          <TestsSummary onLoaded={onLoaded} allDone={allDone}/>

          {/* ----end:: TEST---- */}
          {/* ----start:: PAYMENTS---- */}
          <PaymentSummary onLoaded={onLoaded} allDone={allDone}/>
          {/* ----end:: PAYMENTS---- */}
          {/* ----start:: LESSONS---- */}
          <LessonsSummary onLoaded={onLoaded} allDone={allDone}/>
          {/* ----end:: LESSONS---- */}
        </div>
      </div>
    </>
  );
};

export { ActionCentre };
